import React from 'react';

const BrandList = [
    {
        image: './images/brand/gcc.png'
    },
    {
        image: './images/brand/usg.png'
    },
    {
        image: './images/brand/panelrey.png'
    },


    {
        image: './images/brand/niasa.png'
    },
    {
        image: './images/brand/maximo.png'
    },
    {
        image: './images/brand/fanal.png'
    },
    {
        image: './images/brand/deacero.png'
    },


]

const BrandConstruccion = ({ brandStyle }) => {
    return (
        <ul className={`brand-list ${brandStyle}`}>
            {BrandList.map((data, index) => (
                <li key={index}>
                    <a href="#"><img src={`${data.image}`} alt="Brand Image" /></a>
                </li>
            ))}
        </ul>
    )
}

export default BrandConstruccion;
